const UUID_PLACEHOLDER = ":uuid";
export var AppRoutes;
(function (AppRoutes) {
    AppRoutes["Home"] = "/";
    AppRoutes["User"] = "/user";
    AppRoutes["Registrations"] = "/user/registrations";
    AppRoutes["RegistrationsDetail"] = "/user/registrations/:uuid";
    AppRoutes["Operations"] = "/user/operations";
    AppRoutes["OperationsDetail"] = "/user/operations/:uuid";
    AppRoutes["AuditLog"] = "/user/audit";
    AppRoutes["AuditLogDetail"] = "/user/audit/:uuid";
    AppRoutes["Errors"] = "/errors";
    AppRoutes["Setup"] = "/setup";
    AppRoutes["Login"] = "/login";
    AppRoutes["OAuthLogin"] = "/oauth";
    AppRoutes["OAuthCallback"] = "/oauth_callback";
    AppRoutes["OAuthLogout"] = "/oauth_logout";
})(AppRoutes || (AppRoutes = {}));
export function getAppRouteFromPathname(pathname) {
    // replace UUID in pathname with :uuid to get exact route mapping
    const [updatedPath, uuid] = replaceUUIDWithPlaceholder(pathname, UUID_PLACEHOLDER);
    const routes = Object.values(AppRoutes);
    const matchedRoute = routes
        .filter(route => updatedPath.startsWith(route))
        .sort((a, b) => b.length - a.length)[0]; // Sort by length to match the most specific route
    return matchedRoute ? { route: matchedRoute, uuid } : null;
}
const replaceUUIDWithPlaceholder = (input, placeholder) => {
    let uuid = "";
    const output = input.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, (match) => {
        uuid = match;
        return placeholder;
    });
    return [output, uuid];
};
